/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     首页 API 接口
  | @Version:   2019-03-18  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'

const jsApiHost = process.env.VUE_APP_GENERAL_API_HOST

export function getIndexTbdApi(params) {
  return request({
    url: '?c=fam&a=home&do=todo',
    method: 'get',
    params
  })
}

export function getUserEquipVisitLogApi(params) {
  return request({
    url:'?c=fam&a=behavior&do=equipvisit',
    method: 'get',
    params
  })
}

export function getIndexConditionApi(params) {
  return request({
    url: '?c=fam&a=home&do=overview',
    method: 'get',
    params
  })
}

export function godScheduleTodoApi(params) {
  return request({
    url: `${jsApiHost}/god/todo/stat`,
    method: 'get',
    params
  })
}

export function godSearchApi(params) {
  return request({
    url: `${jsApiHost}/god/search`,
    method: 'get',
    params
  })
}
